<template>
  <div>
    <el-dialog
      :title="`${title}查询任务`"
      :visible.sync="show"
      width="1200px"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <el-form :model="formData" :rules="ruleValidate" ref="answerForm" label-width="100px" v-loading="loading" style="height: 85%">
        <el-row>
          <el-col :span="12">
            <el-form-item label="名称：" prop="name">
              <el-input v-model="formData.name" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="图标" prop="icon" style="min-width: 250px;">
          <div>
            <el-upload
              v-show="!fileList.length"
              class="upload-demo"
              action="#"
              accept="image/jpeg,image/png"
              :show-file-list="false"
              :before-upload="handleBeforeUpload"
              :on-preview="handlePreview"
            >
              <div>
                <el-button slot="trigger"  v-if="!fileList.length>=1">
                  上传<i class="el-icon-upload el-icon--right"></i>
                </el-button>
              </div>
            </el-upload>
            <div  v-show="!fileList.length" class="el-upload-tip">图片不超过1M。JPG、PNG格式</div>
            <div v-if="fileList.length">
              <el-image
                style="width: 95px;height: 50px;"
                class="card-shadow"
                :src="fileList[0].url"
                fit="contain"
                @click="handlePreview"
              ></el-image>
              <span @click="handleRemove"><i class="el-icon-delete"></i></span>
            </div>
            <el-input v-model="formData.icon" style="display: none"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="SQL：" prop="querySql">
          <el-input type="textarea" :rows="2" v-model="formData.querySql" ></el-input>
        </el-form-item>
        <el-form-item label="显示模板：" prop="type">
          <el-select v-model="formData.type" placeholder="请选择">
            <el-option label="单个查询模板" :value="0"></el-option>
            <el-option label="批量查询模板" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="展示字段：">
          <el-button icon="el-icon-plus" @click="addQueryResultDefList"></el-button>
        </el-form-item>

        <ShowItemForm 
          ref="showItemForm" 
          v-for="(item, index) in formData.queryResultDefList" 
          :key="item.key" 
          @showItemFormChange="showItemFormChange" 
          @removeItemForm="removeItemForm"
          :itemIndex="index"
          :myKey="item.key"
          :itemData="item"
        />

        <el-form-item label="查询条件：">
          <el-button icon="el-icon-plus" @click="addQueryCondDefList"></el-button>
        </el-form-item>

        <SearchItemForm 
          ref="searchItemForm" 
          v-for="(item, index) in formData.queryCondDefList" 
          :key="item.key" 
          @searchItemFormChange="searchItemFormChange" 
          @removeItemForm="removeItemForm"
          :itemIndex="index"
          :myKey="item.key"
          :itemData="item"
        />
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSubmit" :disabled="loading">确 定</el-button>
        <el-button @click="handleClose" :disabled="loading">取 消</el-button>
      </span>
    </el-dialog>

    <cropperImg ref="cropperImg" :autoCropWidth="200" :autoCropHeight="200" @uploadHttp="uploadHttp"/>
  </div>
</template>

<script>
import cropperImg from '@/components/common/cropperImg.vue'
import ShowItemForm from './showItemForm'
import SearchItemForm from './searchItemForm'
import { sysFileUpload, sysFileDelete } from '@/api/managementCenter/otherApi';
import { sysDatasourceQuerySave, sysDatasourceQueryId, sysDatasourceQueryUpdate } from '@/api/management/search';

export default {
  name: "Add",
  components: {
    cropperImg,
    ShowItemForm,
    SearchItemForm,
  },
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      show: false,
      loading: false,
      formData: {
        name: '',
        icon: '',
        querySql: '',
        type: '',
        queryResultDefList: [],
        queryCondDefList: [],
      },
      ruleValidate: {
        name: [
          {required: true, message: '名称不能为空', trigger: 'blur'}
        ],
        // icon: [
        //   {required: true, message: '请上传图标', trigger: 'blur'}
        // ],
        querySql: [
          {required: true, message: 'SQL不能为空', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '请选择显示模板', trigger: 'blur'}
        ],
      },
      fileList: [],
      title: '新增',
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {},
  destroyed() {},
  methods: {
    handleClose(){
      this.resetForm()
      this.show = false
    },
    resetForm(){
      this.formData = {
        id: '',
        name: '',
        icon: '',
        querySql: '',
        type: '',
        queryResultDefList: [],
        queryCondDefList: [],
      }
      this.fileList = []
      this.$refs.answerForm.resetFields()
    },
    dialogOpen(row){
      this.show = true

      if(row){
        this.title = '编辑'
        this.loading = true

        sysDatasourceQueryId(row.id)
        .then(({data}) => {
          if(data.code == 0){
            const resData = data.data;
            this.formData.name = resData.name
            this.formData.id = resData.id
            this.formData.querySql = resData.querySql
            this.formData.type = Number(resData.type)
            this.formData.queryResultDefList = resData.queryResultDefList
            this.formData.queryCondDefList = resData.queryCondDefList
            if(resData.icon){
              this.fileList = [{
                id: resData.icon,
                url: resData.iconUrl
              }];
            }
            this.$refs.showItemForm.forEach(item => {
              item.setDefualtData()
            })
            this.$refs.searchItemForm.forEach(item => {
              item.setDefualtData()
            })
          }else {
            this.$message.error(data.msg || '请求出错')
          }
        }).finally(() => {
          this.loading = false
        })
      }

      if(this.formData.queryResultDefList.length==0){
        this.addQueryResultDefList()
      }
      if(this.formData.queryCondDefList.length==0){
        this.addQueryCondDefList()
      }
    },
    handleBeforeUpload(file){
      if(this.fileList.length>0){
        return this.$message.error('只能上传一张专题图片！');
      }
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        this.$message.error('上传图片大小不能超过 1MB!');
        return isLt1M
      }
      this.$refs.cropperImg.uploadImg(file);
      return;
    },
    uploadHttp(file){
      let fd = new FormData();
      fd.append('fromTarget',2)
      fd.append('file',file);
      //上传到后台
      this.loading=true
      sysFileUpload(fd).then(({data}) => {
        this.loading=false
        if(data.code == 0) {
          this.$refs.cropperImg.closeDialog();
          this.$message.success(  "上传文件成功!" );
          this.fileList.push(
            {
              ...data.data
            }
          )
        }else{
          this.$message.warning( data.msg || "上传文件失败!" );
        }
      }).catch(err=>{
        this.loading=false
        this.$message.error(  "上传文件异常!" );
      });
    },
    handlePreview(){
      window.open(this.fileList[0].url)
    },
    handleRemove() {
      this.deleteFile(this.fileList[0].id)
      this.fileList=[]
    },
    deleteFile(id){
      sysFileDelete(id).then(({data}) => {
        if(data.code == 0){
          this.$message.success(  "删除成功!" );
        }else{
          this.$message.warning(data.msg|| "删除失败！" );
        }
      }).catch(err=>{
        this.$message.error( "删除异常!" );
      })
    },
    addQueryResultDefList(){
      this.formData.queryResultDefList.push({
        exchange: [],
        fieldName: '',
        fieldType: '',
        showName: '',
        key: (new Date()).getTime(),  // 唯一标识避免渲染错误
      })
    },
    addQueryCondDefList(){
      this.formData.queryCondDefList.push({
        exchange: [],
        type: '',
        queryField: '',
        showName: '',
        key: (new Date()).getTime() + 1,  // 唯一标识避免渲染错误
      })
    },
    removeItemForm(obj){
      this.formData[obj.dataName].splice(obj.index, 1)
    },
    showItemFormChange(obj){
      this.formData.queryResultDefList[obj.index] = obj.data
    },
    searchItemFormChange(obj){
      this.formData.queryCondDefList[obj.index] = obj.data
    },
    addSubmit(){
      const _this = this
      this.$refs.answerForm.validate((valid) => {
        Promise.all([_this.validateChildrenForm('showItemForm', 'queryResultDefList'), _this.validateChildrenForm('searchItemForm', 'queryCondDefList')])
        .then((res) => {
          if(valid && res){
            // this.formData.queryResultDefList = res[0];
            // this.formData.queryCondDefList = res[1];
            this.loading = true
            let rq = this.title === '新增' ? sysDatasourceQuerySave : sysDatasourceQueryUpdate
            rq(this.formData)
            .then(({data}) => {
              if(data.code == 0){
                this.$message.success('操作成功')
                this.resetForm()
                this.$emit('refresh')
                this.show = false
              }else{
                this.$message.error(data.msg || '请求出现异常, 保存失败')
              }
            }).finally(() => {
              this.loading = false
            })
          }
        })
      })
    },
    validateChildrenForm(formName, listName){
      let resultArr = []
      const _this = this;
      function checkForm(index) {
        let result = new Promise(function(resolve, reject) {
          _this.$refs[formName][index].$refs.cFrom.validate((valid) => {
            if (valid) {
              resolve(_this.$refs[formName][index].getValue());
            } else {
              reject()
            }
          })
        })
        resultArr.push(result)
      }
      this.formData[listName].forEach((item, index) => {
        checkForm(index)
      });
      return new Promise(resolve => {
        Promise.all(resultArr).then((res) => {
          resolve(res)
        })
      })
    },
  },
  watch: {
    fileList(value){
      if(value.length){
        this.formData.icon = value[0].id
      }else{
        this.formData.icon = ""
      }
    },
  },
  filters: {}
};
</script>

<style scoped lang="less">
</style>
